import { render, staticRenderFns } from "./EventsViewTabsResults.vue?vue&type=template&id=bd4a0362&"
import script from "./EventsViewTabsResults.vue?vue&type=script&lang=ts&"
export * from "./EventsViewTabsResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EventsViewTabsResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports